export default __webpack_public_path__ + "static/media/480_dummy2016-kunstgalerie01-de.48520656.png";